<template>
    <div class="wlx-provincia-head">

        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">省级工作室</span>
            </div>
            <div class="fr btn-right">
                <el-form :inline="true" size="small">
                    <div class="d-search-form-news">
                        <el-form-item>
                            <el-input v-model="provinceName" placeholder="请输入站点名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>

        <div class="yk-wrap-fixed clearfix">
            <!-- 新增/修改站点 -->
            <el-dialog title="设置联系人" v-if="addNewNoticeVisible" :visible.sync="addNewNoticeVisible" :before-close="cancel" :append-to-body="true" width="30%" :close-on-click-modal="false">
                <div>
                    <el-form ref="ruleForm" label-width="160px">
                        <el-form-item label="联系人姓名">
                            <el-input v-model="Contacts"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人电话">
                            <el-input v-model="ContactsPhone"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addNewNoticeVisible = false">取 消</el-button>
                    <el-button type="primary" @click="setProvincialHead()">确 定</el-button>
                </span>
            </el-dialog>
            <div>
                <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark" @selection-change="handleSelectionChange">
                    <el-table-column prop="id" type="selection" width="55"></el-table-column>
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column prop="ProvinceName" label="省份"></el-table-column>
                    <el-table-column prop="Contacts" label="联系人姓名"></el-table-column>
                    <el-table-column prop="ContactsPhone" label="联系人电话"></el-table-column>
                    <el-table-column label="操作" width="180">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="设置联系人" placement="top-start">
                                <el-button size="mini" class="el-icon-edit" @click="edit(scope.row)" type="primary"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="news-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            addNewNoticeVisible: false,
            /* -----------添加/修改弹框参数------------ */
            id: "",
            provinceName: "",
            Contacts: "",
            ContactsPhone: "",
            /* --------------------------------------- */
        };
    },
    created() {
        this.school = this.$store.state.auth.userName;
        this.getProvincialHeadList(1);
    },
    methods: {
        getProvincialHeadList(page) {
            var that = this;
            this.$http
                .post("/api/XOrg/ProvincialHead/getProvincialHeadList", {
                    provinceName: this.provinceName,
                    page: page,
                    pageSize: this.pageSize,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        this.list = rst.list;
                        this.total = rst.pagination.totalCount;
                        this.pageSize = rst.pagination.pageSize;
                        this.pageIndex = rst.pagination.pageIndex;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        onPageChangeHandler(page) {
            this.getProvincialHeadList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getProvincialHeadList();
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.id);
            });
        },
        setProvincialHead() {
            var that = this;
            this.$http
                .post("/api/XOrg/ProvincialHead/setProvincialHead", {
                    id: that.id,
                    contacts: that.Contacts,
                    contactsPhone: that.ContactsPhone,
                })
                .then((rst) => {
                    if (rst.code === 1) {
                        that.$message.success(rst.msg);
                        that.getProvincialHeadList();
                        that.addNewNoticeVisible = false;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        edit(row) {
            this.addNewNoticeVisible = true;
            this.id = row.Id;
            this.Contacts = row.Contacts;
            this.ContactsPhone = row.ContactsPhone;
        },
        cancel() {
            this.addNewNoticeVisible = false;
        },
        search() {
            this.getProvincialHeadList(1);
        },
    },
};
</script>

<style lang="scss">
.wlx-provincia-head {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
